import React, { useEffect, useRef } from "react";

import { QrReader } from "react-qr-reader";
import { useDeviceType } from "../../hooks/useDeviceType/Index";
import useQr from "../../hooks/useQr";
import useSimplePopup from "../../hooks/useSimplePopup";

type Props = {
  onResult?: (result: any, error: any) => void;
  onClose?: () => void;
};

export default function QrCodeReader({ onResult, onClose }: Props) {
  const prevData = useRef<string>("");
  const deviceType = useDeviceType();
  const [simplePopupComponent, { open }] = useSimplePopup({});
  const [qrResult, qrCall] = useQr({
    open: (message: string) => {
      open(message, { onClick: () => onClose?.() });
    },
  });

  useEffect(() => {
    if (qrResult.isLoading === false) {
      if (qrResult.result) {
        onResult?.(qrResult.result, null);
      } else {
        // nothing to do
      }
      onClose?.();
    }
  }, [qrResult.result, qrResult.isLoading]);

  useEffect(() => {
    if (deviceType === "Android" && window.SANDI?.qr) {
      qrCall();
    } else if (deviceType === "iOS" && window.webkit?.messageHandlers?.qr) {
      qrCall();
    }
    // }
    // open("대여를 신청한 장소가 아닙니다.\n대여 장소를 확인해주세요");
  }, [deviceType]);

  return (
    <>
      {!window.webkit?.messageHandlers?.qr && !window.SANDI?.qr && (
        <>
          <div className="fixed bg-black inset-0 z-50">
            <QrReader
              onResult={(result, error) => {
                if (result?.getText() === prevData.current) {
                  return;
                }
                prevData.current = result?.getText() ?? "";

                if (!!error) {
                  // console.info(error);
                }

                if (result) {
                  onResult?.(result?.getText(), error);
                  onClose?.();
                }
              }}
              videoContainerStyle={{
                width: "100vw",
                height: "100vh",
              }}
              videoStyle={{
                width: "100vw",
                height: "100vh",
              }}
              constraints={{ facingMode: "environment" }}
            />

            {/* <p className="absolute bottom-5 left-1/2 -translate-x-1/2 text-white text-center z-50">
              {prevData.current}
            </p> */}
            <div
              className=" whitespace-pre-line fixed text-white left-1/2 -translate-x-1/2 w-[300px] text-xl font-semibold text-center z-30"
              style={{ top: "calc(50vh + 170px)" }}
            >
              {"QR코드의 초점이 흐려지거나\n빛이 반사되지 않는지 확인하세요"}
            </div>
            <div
              className="fixed inset-0 z-30"
              style={{
                top: "0px",
                left: "0px",
                zIndex: 1,
                boxSizing: "border-box",
                border: "50px solid rgba(0, 0, 0, 0.6)",
                borderTopWidth: "calc(50vh - 150px)",
                borderRightWidth: "calc(50vw - 150px)",
                borderBottomWidth: "calc(50vh - 150px)",
                borderLeftWidth: "calc(50vw - 150px)",
                width: "100%",
                height: "100%",
              }}
            ></div>
            <div
              className="fixed top-[60px] right-5 z-30"
              onClick={() => onClose?.()}
            >
              <QrReaderCloseIcon />
            </div>
          </div>

          {simplePopupComponent}
        </>
      )}
    </>
  );
}

export const QrReaderCloseIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18 6L6 18"
        stroke="white"
        strokeWidth="1.75"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M6 6L18 18"
        stroke="white"
        strokeWidth="1.75"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
    </svg>
  );
};
